export const Status = {
  CONFIRMED: "CONFIRMED",
  DECLINED: "DECLINED",
  NEW_TIME: "NEW_TIME",
};

export const BookingStatus = {
  OPENED: "OPENED",
  REQUESTED: "REQUESTED",
  BOOKED: "BOOKED",
  CHECKEDOUT: "CHECKEDOUT",
  NEW_TIME: "NEW_TIME",
};

export const PayoutStatusEnum = {
  PENDING: "PENDING",
  PAID: "PAID",
  NOT_NEEDED: "NOT_NEEDED",
};
